
import React, { Component } from 'react';
import { RightOutlined, InfoCircleOutlined, EllipsisOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { AREA_invite_collaborators, AREA_create_build, AREA_create_area, AREA_create_group, AREA_click_group, deviceNo, AREA_select_build, AREA_select_area, SPIN_DIALOG_Devices_SHOW, SPIN_DIALOG_Devices_HIDE } from "../../../const/infoConst";
import './areaManagePage.less';
import PubSub from 'pubsub-js';
import build from "../../../imgs/item/build.png";
import area from "../../../imgs/item/area.png";
import group from "../../../imgs/item/group.png";
import btn_add from "../../../imgs/btn/btn_add.png";
import arrow_right from "../../../imgs/btn/arrow_right.png";
import { meshLog, SPRemove, SPGet, SPSet } from "../../../utils/spUtils";
import { getGroupNormalImgWithName, getGrouelectImgWithName } from '../../../utils/fileUtils';
import { getBuildingArr, getMeshArr, getDefaultMeshName, getSelectBuildingTime, getSelectBuildingAddr } from '../../../utils/meshUtils';
import { changeSelectBuilding } from '../../../utils/net/netUtils';
import { Color } from 'antd/es/color-picker';
import { sendOpcode_group_state, sendOpcode_alldevices_state } from '../../../utils/opcodeUtils';
import btn_refresh from "../../../imgs/btn/btn_refresh.png";

export default class AreaManagePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            building_arr: [], //building下拉菜单
            building_select: "",
            building_time: "",
            building_info: "",

            mesh_arr: [], //mesh下拉菜单
            mesh_select: getDefaultMeshName(),

            groupList: [], //group集合
            group_selectId: 0,
        };
    }

    componentDidMount() {
        this.updatePageUI();
        PubSub.subscribe('changeMeshUpdateUI', (msg, data) => {
            meshLog('datadatadata', data);
            if (data == 1) {
                meshLog('不修改左边组的信息格式',);
            } else {
                this.updatePageUI();
            }
        })
    }

    //刷新UI
    updatePageUI() {
        const groupList = JSON.parse(SPGet("groupList"))
        let name = SPGet("SelectBuildingName");
        SPSet("groupInfo", JSON.stringify(groupList[0]))
        this.setState({
            building_arr: getBuildingArr(),
            building_select: name,
            building_time: getSelectBuildingTime(name),
            building_info: getSelectBuildingAddr(name),
            mesh_arr: getMeshArr(),
            mesh_select: SPGet("SelectMeshName"),
            groupList: groupList,
            group_selectId: groupList[0].groupID,
        });;
    }


    //切换building
    buildingChangeClick() {
        this.props.onDataToParent(AREA_select_build);
    }


    //切换mesh
    areaChangeClick() {
        this.props.onDataToParent(AREA_select_area);
    }

    //更新UI
    sendDataToParent_build() {
        PubSub.publish("update_build_data_ui", '');
        this.props.onDataToParent(AREA_create_build);
    };
    sendDataToParent_area() {
        PubSub.publish("update_area_data_ui", '');
        this.props.onDataToParent(AREA_create_area);
    };
    sendDataToParent_group() {
        this.props.onDataToParent(AREA_create_group);
    };
    //点击group item
    sendDataToParent_map(office) {
        this.setState({ group_selectId: office.groupID });
        //修改组信息，需要同步的弹框
        this.props.onDataToParent(AREA_click_group);
        meshLog('group', office, office.groupID);
        SPSet("groupInfo", JSON.stringify(office))
        PubSub.publish('updateGroupdataUI', '')//刷新组的数据

        //获取组的状态，通过网关来返回的
        sendOpcode_group_state()
        meshLog('获取组的状态',);
    };

    controlRefreshGateway = () => {
        //让网关获取所有的设备信息
        sendOpcode_alldevices_state()
        meshLog('获网关获取所有的设备信息',);

        PubSub.publish(SPIN_DIALOG_Devices_SHOW, '');//加载框
        setTimeout(() => {
            PubSub.publish(SPIN_DIALOG_Devices_HIDE, '');
        }, 5000)

    }


    render() {
        return (
            <div className="area-management-container">
                {/* Area Management */}
                <div className="header-row">
                    <span>Area Management</span>
                    {/* <InfoCircleOutlined className="header-icon" /> */}
                </div>

                {/* Building*/}
                <div className="section">
                    <div className="section-header">
                        <div className="action-title">
                            <img src={build} />
                            <span>Create Building</span>
                        </div>

                        <div className="action-group">
                            <img src={btn_add} onClick={this.sendDataToParent_build.bind(this)} />
                        </div>
                    </div>

                    <div className="dropdown_build" onClick={() => { this.buildingChangeClick() }}>
                        <div className='build_name'>
                            <span>{this.state.building_select}</span>
                            <img src={arrow_right} />
                        </div>
                        <div className='build_time'>
                            <span className='time1'>Date Created</span>
                            <span className='time2'>{this.state.building_time}</span>
                        </div>
                        <span className='build_info'>{this.state.building_info}</span>

                    </div>
                </div>

                {/* Area */}
                <div className="section">
                    <div className="section-header">
                        <div className="action-title">
                            <img src={area} />
                            <span>Create a Area Floor Plan</span>
                        </div>

                        <div className="action-group">
                            <img src={btn_add} onClick={this.sendDataToParent_area.bind(this)} />
                        </div>
                    </div>

                    <div className="dropdown_mesh" onClick={() => { this.areaChangeClick() }}>
                        <span>{this.state.mesh_select}</span>
                        <img src={arrow_right} />
                    </div>
                </div>

                <div className="section">
                    <div className="section-header">
                        <div className="action-title">
                            <img src={area} />
                            <span>Update Devices Info</span>
                        </div>
                        <div className="action-group">
                            <img src={btn_refresh} onClick={() => { this.controlRefreshGateway() }} />
                        </div>
                    </div>


                </div>

                {/* Group */}
                <div className="section">
                    <div className="section-header">
                        <div className="action-title">
                            <img src={group} />
                            <span>Create Group</span>
                        </div>

                        <div className="action-group">
                            <img src={btn_add} onClick={this.sendDataToParent_group.bind(this)} />
                        </div>
                    </div>


                    <div className="office-list">
                        {this.state.groupList.map((office) => (
                            <div key={office.name} className="office-item">
                                <div className='item_left' onClick={() => this.sendDataToParent_map(office)}>
                                    <img className="group-icon" src={getGroupNormalImgWithName(office.groupImgName)} />
                                    <span style={{ color: this.state.group_selectId == office.groupID ? "#0B47BE" : "#595757" }}>{office.name}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
